module.exports = __webpack_public_path__ + "static/img/img1x.cc70f78.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/family/img1x.png
// module id = q+HV
// module chunks = 1